<template>
  <ion-app id="app">
      <ion-header class="web-ion-header" ref="nav">
        <div class="custom-toolbar">
           <nav class="container" style="padding: 0 1em;">
               <router-link to="/">
                    <img :src="isSubscribed ? `img/lawyerly-premium.png`:`img/logo.webp`" style="height: 45px;" />
                </router-link>
                <span style="margin: 0 0.5em;"></span>
               <div v-for="(item, idx) in links" :key="idx" class="desktop-navlinks">
                    <router-link :to="item.path">
                        <ion-title mode="md">{{item.label}}</ion-title>
                    </router-link>
               </div>
                <span style="flex-grow: 1;"></span>
                <ion-spinner color="light" v-if="$store.state.ui.showSpinner"></ion-spinner>
                <div class="desktop-navlinks">
                  <router-link title="Settings" to="/settings">
                      <ion-icon style="font-size: 28px;" name="settings"></ion-icon>
                  </router-link>
                </div>
                <div v-if="isLoggedIn" class="desktop-navlinks dropdown">
                    <a class="dropbtn" href="#">
                        <!-- <ion-title mode="md" style="padding: 0;">
                           {{$store.state.user.user.name}}
                        </ion-title> -->
                        <div class="profile notif-badge"></div>
                        <img :class="$store.state.user.user.subscription.status == 'active' ? `profile-initial premium` : `profile-initial`"
                          referrerpolicy="no-referrer"
                          :src="profilePic"/>
                        <ion-icon style="font-size: 20px; margin: auto 8px auto;" name="arrow-dropdown"></ion-icon>
                    </a>
                    <div class="dropdown-content">
                        <router-link to="/profile">
                          <ion-title mode="md">Profile</ion-title>
                          <div class="link notif-badge"></div>
                        </router-link>
                        <a @click="logout">
                          <ion-title mode="md">Logout</ion-title>
                        </a>
                    </div>
                </div>
                 <div v-else class="desktop-navlinks">
                    <router-link to="/profile/login">
                        <ion-title mode="md">Sign In</ion-title>
                    </router-link>
                </div>
                <ion-button fill="outline" class="menu-button" @click="toggleMenu">
                  <ion-icon slot="icon-only" class="menu-button-icon" name="menu"></ion-icon>
                </ion-button>
           </nav>
           <div :class="isOpen ? 'mobile-custom-toolbar active' : 'mobile-custom-toolbar'">
            <span style="padding: 0.25em;"></span>
            <div v-for="(item, idx) in links" :key="idx" @click="toggleMenu">
                <router-link :to="item.path">
                    <ion-title mode="md">{{item.label}}</ion-title>
                </router-link>
            </div>
            <div @click="toggleMenu">
                <router-link to="/settings">
                    <ion-title mode="md">Settings</ion-title>
                </router-link>
            </div>
            <div v-if="isLoggedIn">
              <a @click="toggleSubMenu" style="display: flex;">
                  <ion-title mode="md" style="height: 32px;">
                    <img :class="$store.state.user.user.subscription.status == 'active' ? `profile-initial-mobile premium` : `profile-initial-mobile`" :src="`https://ui-avatars.com/api/?length=1&name=${$store.state.user.user.name}&bold=true&rounded=true&background=3498DB&color=ffffff&font-size=0.60&size=24`"/>
                    {{$store.state.user.user.name}}
                  </ion-title>
                  <ion-icon style="font-size: 20px; margin: auto; color: #fff;" :name="subMenu ? 'arrow-dropup' : 'arrow-dropdown'"></ion-icon>
              </a>
            </div>
            <div v-else @click="toggleMenu">
                <router-link to="/profile/login">
                  <ion-title mode="md">Sign In</ion-title>
                </router-link>
            </div>
            <div v-if="isLoggedIn" :class="subMenu ? 'mobile-submenu active' : 'mobile-submenu'">
                <div @click="toggleMenu">
                  <router-link v-for="(item, idx) in sublinks" :key="idx" :to="item.path">
                      <ion-title mode="md" style="padding: 0 2em;">{{item.label}}</ion-title>
                  </router-link>
                  <a @click="logout">
                      <ion-title mode="md" style="padding: 0 2em;">Logout</ion-title>
                  </a>
                </div>
            </div>
           </div>
        </div>
      </ion-header>
    <ion-content overflow-scroll="true" main ref="ionContent">
      <ion-page class="container content">
        <div style="min-height: calc(100vh - 134px); padding-bottom: 1em;">
            <!-- Web Toolbar -->
            <div class="web-toolbar">
              <ion-button v-if="$route.meta.showBack" fill="clear" strong @click="searchAnother">
                  <ion-icon md="md-arrow-round-back" ios="md-arrow-round-back"></ion-icon> <label class="header-toolbar-label">BACK</label>
              </ion-button>
              <div style="flex-grow: 1;"></div>
              <ion-button
               v-for="(btn, idx) in $store.state.ui.moreHeaderButtons.web"
               :key="idx+btn.icon"
               fill="clear"
               @click="$root.$emit(btn.emit, $event, btn)"
               :disabled="btn.disabled"
               strong
              >
                  <ion-icon v-if="!btn.icon.startsWith('custom')" :md="'md-'+btn.icon" :ios="'md-'+btn.icon"></ion-icon>
                  <span v-else v-html="getIcon(btn.icon)"></span> 
                  <label class="header-toolbar-label">{{btn.label.toUpperCase()}}</label>
              </ion-button>
              <ion-button
               v-if="$store.state.ui.showClearHighlights"
               fill="clear"
               @click="$root.$emit('header-command', $event, {cmd: 'clear'})"
               strong
              >
                  <ion-icon md="md-close" ios="md-close"></ion-icon> <label class="header-toolbar-label">CLEAR</label>
              </ion-button>
          </div>

          <router-view />
        </div>
        <ion-footer class="footer">
          <div class="footer-container">
            <div class="footer-links">
              <div class="footer-link" v-for="(link, idx) in footerLinks" :key="idx">
                <router-link router-link :to="link.path">
                    <ion-title mode="md">
                      {{link.label}}
                    </ion-title>
                  </router-link>
                  <span v-if="idx != (footerLinks.length - 1)">|</span>
              </div>
            </div>
          </div>
        </ion-footer>
      </ion-page>
    </ion-content>
  </ion-app>
</template>
<script>
import debounce from "debounce";
import Icons from "../components/annot8/icons";
// import { firebase as $firebase } from "@/firebase";
export default {
    data() {
      return {
        isOpen: false,
        subMenu: false,
        links: [
          {label: "Cases", path: "/cases"},
          {label: "Laws", path: "/laws"},
          {label: "Notebooks", path: "/notebooks"},
          {label: "Digests", path: "/digests"}
        ],
        sublinks: [
          {label: "Profile", path: "/profile"}
        ],
        footerLinks: [
          {label: "Copyright Notice", path: "/legal?to=copyright-notice"},
          {label: "Disclaimer", path: "/legal?to=disclaimer"},
          {label: "Terms of Service", path: "/legal?to=term-of-service"},
          {label: "Privacy", path: "/legal?to=privacy"},
          {label: "Content Policy", path: "/legal?to=content-policy"},
          {label: "Contact Us", path: "/legal?to=contact-us"}
        ]
      }
    },
    computed: {
        username() {
            return (this.$store.state.user.user.email || "").split("@")[0];
        },
        isLoggedIn() {
            if(this.$store.state.user.user.email){
                return true;
            }
            return false;
        },
        profilePic() {
          if(this.$store.state.user.user.auth) {
            if(this.$store.state.user.user.auth.picture) {
              return this.$store.state.user.user.auth.picture;
            }
          }
          return `https://ui-avatars.com/api/?length=1&name=${this.$store.state.user.user.name}&bold=true&rounded=true&background=3498DB&color=ffffff&font-size=0.60&size=32`
        },
        isSubscribed() {
          if(!this.$store.state.user.user.subscription) {
            return false;
          }
          return this.$store.state.user.user.subscription.status == 'active';
        }
    },
    methods: {
      async logout() {

        import(/* webpackChunkName: "logout" */'@/firebase')
        .then($firebase => {
          $firebase.firebase.auth().signOut();
        });

        this.$http.get(this.$config.api.url + "/logout").finally(()=>{

          delete this.$http.defaults.headers.common["Authorization"];
          this.$store.commit("user/setUser", null);
          this.$ionic.showToast(
            "You have been logged out.",
            {
              duration: 3500,
              position: "bottom"
            }
          );

          if(this.$route.path !== '/dashboard') {
            this.$router.replace("/dashboard");
          }
          
        });

      },
      toggleMenu() {
        this.isOpen = !this.isOpen;
      },
      toggleSubMenu() {
        this.subMenu = !this.subMenu;
      },
      searchAnother() {
        // const to = this.$route.path.split("/")[1];
        // this.$router.push("/" + to);
        this.$router.go(-1);
      },
      getIcon(icon) {
        return Icons[icon.replace('custom-', '')];
      },
      handleScroll(event) {
        // Any code to be executed when the window is scrolled
        const scrollAmnt = event.detail.currentY - event.detail.startY;
        if(scrollAmnt > 0) {
          const nav = this.$refs['nav'];
          nav.style.overflow = 'hidden';
          nav.style.height = '0px';

        } else {
          const nav = this.$refs['nav'];
          nav.style.removeProperty('height');
        }
      },
      whichTransitionEvent(el) {
        var t;
        var transitions = {
          'transition':'transitionend',
          'OTransition':'oTransitionEnd',
          'MozTransition':'transitionend',
          'WebkitTransition':'webkitTransitionEnd'
        }

        for(t in transitions){
            if( el.style[t] !== undefined ){
                return transitions[t];
            }
        }
      }
    },
    beforeDestroy() {
    // I switched the example from `destroyed` to `beforeDestroy`
    // to exercise your mind a bit. This lifecycle method works too.
    const debouncedHandeScroll = debounce(this.handleScroll, 50);
    const ionContent = this.$refs['ionContent'];
    ionContent.scrollEvents = false;
    ionContent.removeEventListener('ionScroll', (evt) => {debouncedHandeScroll(evt)});

    /* Listen for a transition! */
    const el = this.$refs['nav'];
    var transitionEvent = this.whichTransitionEvent(el);
    transitionEvent && el.removeEventListener(transitionEvent, () => {
      if(el.style.overflow == "hidden" && !el.style.height) {
        el.style.overflow = "visible";
      }
    });
  },
  watch: {
    "$store.state.route.meta.headerCollapsible": function(n=false, o) {
      if(n) {
        const debouncedHandeScroll = debounce(this.handleScroll, 50);
        const ionContent = this.$refs['ionContent'];
        ionContent.scrollEvents = true;
        ionContent.addEventListener('ionScroll', (evt) => {debouncedHandeScroll(evt)});

        /* Listen for a transition! */
        const el = this.$refs['nav'];
        var transitionEvent = this.whichTransitionEvent(el);
        transitionEvent && el.addEventListener(transitionEvent, () => {
          if(el.style.overflow == "hidden" && !el.style.height) {
            el.style.overflow = "visible";
          }
        });

      } else {
        const debouncedHandeScroll = debounce(this.handleScroll, 50);
        const ionContent = this.$refs['ionContent'];
        ionContent.scrollEvents = false;
        ionContent.removeEventListener('ionScroll', (evt) => {debouncedHandeScroll(evt)});

        /* Listen for a transition! */
        const el = this.$refs['nav'];
        var transitionEvent = this.whichTransitionEvent(el);
        transitionEvent && el.removeEventListener(transitionEvent, () => {
          if(el.style.overflow == "hidden" && !el.style.height) {
            el.style.overflow = "visible";
          }
        });
      }
    }
  }
}
</script>

<style>
  .container, .container > div:first-child {
    margin: auto;
  }

  .container > div:first-child {
    margin: 1em auto;
    margin: 1.5em auto auto auto;
  }

  .desktop-header {
    border-color: #149c82;
    background-color: #18bc9c;
  }

  .desktop-toolbar {
    --background: none;
  }
  
  .desktop-navlinks a ion-title, .desktop-navlinks a ion-icon {
    font-size: 15px;
    font-weight: bold;
    margin: auto;
  }

  .desktop-navlinks a {
    min-width: 48px;
  }

  .desktop-navlinks a {
    padding: 0 0.5em;
    display: flex;
    height: 100%;
    text-decoration: none;
    color: #fff;
  }


  .desktop-navlinks {
    height: 100%;
    display: none;
  }

  .desktop-navlinks:hover > a ion-title, .desktop-navlinks:hover > a ion-icon {
    color: #2c3e50;
  }

  .desktop-navlinks:active > a {
    background: #15a589;
  }

  .desktop-navlinks a.router-link-active {
    background: #15a589;
  }

  .dropdown-content a.router-link-active {
    background: none;
    border-left: 4px #15a589 solid;
  }

    /* Style The Dropdown Button */
    .dropbtn {
        color: white;
        border: none;
        cursor: pointer;
        text-decoration: none;
    }

    /* The container <div> - needed to position the dropdown content */
    .dropdown {
        position: relative;
    }

    /* Dropdown Content (Hidden by Default) */
    .dropdown-content {
        display: none;
        position: absolute;
        top: 70px;
        background-color: #f9f9f9;
        box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
        z-index: 1;
        border: 1px solid rgba(0,0,0,0.2);
        min-width: 175px;
        right: 0;
    }

    /* Links inside the dropdown */
    .dropdown-content a {
        padding: 12px 5px;
        text-decoration: none;
        display: block;
        cursor: pointer;
    }

    .dropdown-content a ion-title {
        --color: black;
    }

    /* Change color of dropdown links on hover */
    .dropdown-content a:hover {background-color:#15a589; color: #ffffff;}
    .dropdown-content a:hover ion-title {color: #ffffff;}

    /* Show the dropdown menu on hover */
    .dropdown:hover .dropdown-content {
        display: block;
    }

    .custom-toolbar {
        width: 100%;
        border-color: #149c82;
        background-color: #18bc9c;
        z-index: 10;
        height: 70px;
    }

    .custom-toolbar > .container {
        display: flex;
        align-items: center;
        height: 100%;
    }

    .mobile-custom-toolbar {
        width: 100%;
        border-color: #149c82;
        background-color: #18bc9c;
        z-index: 15;
        max-height: 0;
        overflow: hidden;
        /* -moz-transition: max-height 1.15s ease-out;
        -ms-transition: max-height 1.15s ease-out;
        -o-transition: max-height 1.15s ease-out;
        -webkit-transition: max-height 1.15s ease-out; */
        transition: max-height 0.7s ease-out;
    }

    .mobile-custom-toolbar.active {
      max-height: 90vh;
    }

    .mobile-custom-toolbar a ion-title {
      font-size: 15px;
      font-weight: bold;
      --color: #fff;
      margin: auto;
      display: block;
    }
    .mobile-custom-toolbar div a{
      text-decoration: none;
      display: block;
      padding: 1em;
    }

    .mobile-custom-toolbar div:active, .mobile-custom-toolbar div a.router-link-active{
      background: #15a589;
      color: #ffffff;
    }

    .mobile-submenu {
      max-height: 0;
      -moz-transition: max-height 0.5s ease-out;
        -ms-transition: max-height 0.5s ease-out;
        -o-transition: max-height 0.5s ease-out;
        -webkit-transition: max-height 0.5s ease-out;
        transition: max-height 0.5s ease-out;
    }

    .mobile-submenu.active {
      max-height: 15em;
    }

    /* .menu-button {
      display: none;
    } */

    .menu-button-icon {
      color: #fff;
    }

  .header-toolbar-label {
      display: none;
  }

  .web-toolbar ion-button ion-icon {
    font-size: 1.5em;
  }

  @media (min-width: 992px) {
    .container, .container > div:first-child {
        width: 970px;
    }

    .footer-container {
        width: 970px;
    }
  }

  @media (min-width: 768px) {
    .container, .container > div:first-child {
        width: 750px;
    }

    .footer-container {
        width: 750px;
    }

    .desktop-navlinks {
      display: block;
    }
    .menu-button, .mobile-custom-toolbar {
      display: none;
    }

    .header-toolbar-label {
       display: block;
    }
  }

  @media (min-width: 1200px) {
    .container, .container > div:first-child {
        width: 1170px;
    }

    .footer-container {
        width: 1170px;
    }
  }

  .web-toolbar {
    margin: 1.5em 0 0;
    display: flex;
    padding: 0 0.5em;
  }

  .web-toolbar ion-button {
    color: #18bc9c !important;
  }

  .web-toolbar ion-button, .web-toolbar ion-button span svg {
    fill: #18bc9c;
  }

  .web-toolbar ion-button ion-icon{
    margin-right: 0.3em;
  }

  .web-toolbar ion-button span {
    margin-right: 0.65em;
  }

   .web-toolbar > ion-button ion-icon, ion-button .header-toolbar-label{ 
    cursor: pointer;
  }

  .vue-simplemde {
    width: 100%;
  }

  .footer {
    width: 100%;
    padding: 10px 0;
    background: #18bc9c;
    display: flex;
    justify-content: center;
  }

  .footer .footer-container .footer-links {
    width: 100%;
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
  }

  .footer .footer-container .footer-links a {
    text-decoration: none;
  }

  .footer .footer-container .footer-links a ion-title{
    color: #fff;
    font-size: 1em;
    padding: 0 0.75em;
  }

  .footer .footer-container .footer-links a ion-title:hover{
    color: #2c3e50;
  }

  .footer-link {
    display: flex;
  }

  .footer-link span{
    color: #fff;
  }

  .web-ion-header {
    transition: height 0.15s ease-in-out;
    height: 70px;
  }

  .dropdown:hover .profile-initial {
    -webkit-box-shadow: 0px 0px 0px 3px rgba(0,0,0,0.3);
    -moz-box-shadow: 0px 0px 0px 3px rgba(0,0,0,0.3);
    box-shadow: 0px 0px 0px 3px rgba(0,0,0,0.3);
  }

  .dropdown:hover .profile-initial.premium {
    -webkit-box-shadow: 0px 0px 0px 4px#fcc200, 0px 0px 0px 7px rgba(0,0,0,0.3);
    -moz-box-shadow: 0px 0px 0px 4px #fcc200, 0px 0px 0px 7px rgba(0,0,0,0.3);
    box-shadow: 0px 0px 0px 4px #fcc200, 0px 0px 0px 7px rgba(0,0,0,0.3);
  }

  .profile.notif-badge {
    position: absolute;
    top: 16px;
    right: 32px;
    height: 10px;
    width: 10px;
  }

  .link.notif-badge {
    position: absolute;
    top: 14px;
    left: 70px;
    height: 8px;
    width: 8px;
  }

  .notif-badge {
    background: #f22613;
    border-radius: 50%;
    display: none;
  }
  
</style>
